import { assign, get, set } from 'lodash';

import { IApplication, IApplicationServers } from './types';
import { IEntity } from '@nrwl/common-lib';

export class Application implements IEntity {
  isDeleted: boolean;
  applicationData: IApplication;
  escapedName: string;
  selected: boolean;

  constructor(dataIn: IApplication) {
    this.escapedName = this.escapeString(dataIn.name);
    this.applicationData = <IApplication>{};
    this.setApplications(dataIn);
    this.isDeleted = get(this.applicationData, 'deleted', false);
  }

  //-------------------------------------------------Application data-------------------------------------------------------
  getApplications(): IApplication {
    return this.applicationData;
  }

  isUserDefined(): boolean {
    const appType = get(this.applicationData, 'applicationType', null);
    return appType === 'User-Defined' || appType === 'User-Defined-Url';
  }

  getId(): string {
    return get(this.applicationData, 'id', null);
  }

  getDescription(): string {
    return get(this.applicationData, 'description', null);
  }

  getName(): string {
    return get(this.applicationData, 'name', null);
  }

  getSite(): string {
    return get(this.applicationData, 'site', null);
  }

  getApplicationServers(): IApplicationServers[] {
    return get(this.applicationData, 'applicationServers', null);
  }

  getUrl(): string {
    return get(this.applicationData, 'url', null);
  }

  getIconUrl(): string {
    return get(this.applicationData, 'iconUrl', null);
  }

  getAppDependencies(): Array<IApplication> {
    return get(this.applicationData, 'appDependencies', null);
  }

  getEscapedName(): string {
    return this.escapedName;
  }

  escapeString(input: string): string {
    if (input) {
      return JSON.stringify(input).replace(/^"(.*)"$/, '$1');
    }
  }

  setId(id: number): string {
    return assign(this.applicationData, 'id', id);
  }

  setApplications(dataIn: IApplication): void {
    assign(this.applicationData, dataIn);
    this.escapedName = this.escapeString(this.applicationData.name);
  }

  setDescription(description: string): void {
    set(this.applicationData, 'description', description);
  }

  setName(name: string): void {
    set(this.applicationData, 'name', name);
  }

  setSite(site: string): void {
    set(this.applicationData, 'site', site);
  }

  setApplicationServers(applicationServers: IApplicationServers): void {
    set(this.applicationData, 'applicationServers', applicationServers);
  }

  setUrl(url: string): void {
    set(this.applicationData, 'url', url);
  }

  setIconUrl(iconUrl: string): void {
    set(this.applicationData, 'iconUrl', iconUrl);
  }

  setAppDependencies(appDependencies: Array<IApplication>): void {
    set(this.applicationData, 'appDependencies', appDependencies);
  }
}
